// Search Modal Functions
function openSearchModal() {
  const overlay = document.querySelector('[data-search-modal-overlay]');
  const modal = document.querySelector('[data-search-modal]');
  
  if (!overlay || !modal) return;

  modal.classList.add('is-visible');
  overlay.classList.add('is-visible');
  
  // Prevent body scroll
  document.body.style.overflow = 'hidden';
  
  // Focus on search input
  const searchInput = modal.querySelector('[data-search-input-modal]');
  if (searchInput) {
    setTimeout(() => searchInput.focus(), 100);
  }
}

function closeSearchModal() {
  const overlay = document.querySelector('[data-search-modal-overlay]');
  const modal = document.querySelector('[data-search-modal]');
  
  if (!overlay || !modal) return;
  
  modal.classList.remove('is-visible');
  overlay.classList.remove('is-visible');
  
  // Restore body scroll
  document.body.style.overflow = '';
}

// Initialize modal triggers
document.addEventListener('DOMContentLoaded', function() {
  // Add click handlers to all search modal triggers
  const triggers = document.querySelectorAll('[data-search-modal-trigger]');
  triggers.forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      openSearchModal();
    });
  });
  
  // Add click handler to close button
  const closeButton = document.querySelector('[data-search-modal-close]');
  if (closeButton) {
    closeButton.addEventListener('click', (e) => {
      e.preventDefault();
      closeSearchModal();
    });
  }
  
  // Close on overlay click
  const overlay = document.querySelector('[data-search-modal-overlay]');
  if (overlay) {
    overlay.addEventListener('click', (e) => {
      // Only close if clicking directly on overlay, not on modal content
      if (e.target === overlay) {
        closeSearchModal();
      }
    });
  }
  
  // Close when clicking outside modal content (on the modal wrapper)
  const modal = document.querySelector('[data-search-modal]');
  if (modal) {
    modal.addEventListener('click', (e) => {
      // Close if clicking outside the content box itself
      const content = modal.querySelector('.search-modal__content');
      if (content && !content.contains(e.target)) {
        closeSearchModal();
      }
    });
  }
  
  // Close on Escape key
  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') {
      const modal = document.querySelector('[data-search-modal]');
      if (modal && modal.classList.contains('is-visible')) {
        closeSearchModal();
      }
    }
  });
});

// Also handle if script loads after DOMContentLoaded
if (document.readyState !== 'loading') {
  const triggers = document.querySelectorAll('[data-search-modal-trigger]');
  triggers.forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      openSearchModal();
    });
  });
  
  // Add click handler to close button
  const closeButton = document.querySelector('[data-search-modal-close]');
  if (closeButton) {
    closeButton.addEventListener('click', (e) => {
      e.preventDefault();
      closeSearchModal();
    });
  }
  
  // Close on overlay click
  const overlay = document.querySelector('[data-search-modal-overlay]');
  if (overlay) {
    overlay.addEventListener('click', (e) => {
      // Only close if clicking directly on overlay, not on modal content
      if (e.target === overlay) {
        closeSearchModal();
      }
    });
  }
  
  // Close when clicking outside modal content (on the modal wrapper)
  const modal = document.querySelector('[data-search-modal]');
  if (modal) {
    modal.addEventListener('click', (e) => {
      // Close if clicking outside the content box itself
      const content = modal.querySelector('.search-modal__content');
      if (content && !content.contains(e.target)) {
        closeSearchModal();
      }
    });
  }
}

// Make functions globally available
window.openSearchModal = openSearchModal;
window.closeSearchModal = closeSearchModal;

// Initialize modal search functionality
if (!window.ModalSearch) {
  class ModalSearch {
    constructor(modalElement) {
      this.modal = modalElement;
      this.input = this.modal.querySelector('[data-search-input-modal]');
      this.resultsContainer = this.modal.querySelector('[data-search-results-container-modal]');
      this.resultsContent = this.modal.querySelector('[data-search-results-content-modal]');
      this.loadingContainer = this.modal.querySelector('[data-search-loading-modal]');
      this.abortController = null;
      this.debounceTimer = null;
      this.currentQuery = '';
      this.moneyFormat = this.modal.dataset.moneyFormat || '{{amount}}';
      this.translations = JSON.parse(this.modal.dataset.translations || '{}');
      this.init();
    }

    init() {
      if (this.input && this.resultsContainer) {
        this.setupEventListeners();
      }
    }

    setupEventListeners() {
      // Debounce function
      const debounce = (func, wait) => {
        return (...args) => {
          clearTimeout(this.debounceTimer);
          this.debounceTimer = setTimeout(() => func.apply(this, args), wait);
        };
      };

      // Handle input changes
      this.input.addEventListener('input', debounce(() => {
        this.handleSearch();
      }, 300));

      // Handle form submission
      const form = this.input.closest('form');
      if (form) {
        form.addEventListener('submit', (e) => {
          const query = this.input.value.trim();
          if (!query) {
            e.preventDefault();
          } else {
            // Allow form to submit normally, which will navigate to search page
            closeSearchModal();
          }
        });
      }
    }

    async handleSearch() {
      const query = this.input.value.trim();
      this.currentQuery = query;

      // Cancel previous request if any
      if (this.abortController) {
        this.abortController.abort();
      }

      if (!query || query.length < 2) {
        this.clearResults();
        return;
      }

      this.showLoading();

      // Create new abort controller for this request
      this.abortController = new AbortController();

      try {
        // Use Shopify's search suggestions endpoint
        const url = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=10`;
        const response = await fetch(url, {
          signal: this.abortController.signal,
          headers: {
            'Accept': 'application/json'
          }
        });

        if (!response.ok) throw new Error('Search failed');

        const data = await response.json();
        this.renderResults(data.resources.results.products, query);
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.error('Search error:', error);
          this.renderError();
        }
      } finally {
        this.hideLoading();
      }
    }

    renderResults(products, query = '') {
      if (!products || products.length === 0) {
        this.resultsContent.innerHTML = `
          <div class="search-modal__empty-state">
            <p class="search-modal__empty-title">${this.translations.no_products_found}</p>
            <p class="search-modal__empty-text">${this.translations.try_different_keywords}</p>
          </div>
        `;
        return;
      }

      const resultsHTML = products.map(product => {
        const imageUrl = product.image || '';
        
        // Helper function to convert price to cents if needed
        const convertToCents = (priceValue, originalValue) => {
          if (!priceValue || priceValue === 0) return 0;
          
          let price = typeof priceValue === 'string' ? parseFloat(priceValue) : Number(priceValue);
          
          // Shopify search suggestions API may return prices in dollars instead of cents
          // If price is a small whole number (< 1000), it's likely in dollars and needs conversion
          if (price > 0 && price < 1000) {
            // Check if original was a string (often indicates dollar format)
            // or if it's a small whole number that makes sense as dollars
            if (typeof originalValue === 'string' || (price === Math.floor(price) && price < 100)) {
              price = Math.round(price * 100); // Convert dollars to cents
            }
          }
          
          return price;
        };
        
        // Check for price range (price_min and price_max)
        const hasPriceRange = product.price_min !== undefined && 
                              product.price_max !== undefined && 
                              product.price_min !== product.price_max;
        
        // Check for compare-at price range
        const hasCompareAtPriceRange = product.compare_at_price_min !== undefined && 
                                       product.compare_at_price_max !== undefined && 
                                       product.compare_at_price_min !== product.compare_at_price_max;
        
        // Get prices - prefer price_min/price_max if available, otherwise use price
        let priceMin = hasPriceRange ? product.price_min : (product.price || 0);
        let priceMax = hasPriceRange ? product.price_max : (product.price || 0);
        let compareAtPriceMin = hasCompareAtPriceRange ? product.compare_at_price_min : (product.compare_at_price || 0);
        let compareAtPriceMax = hasCompareAtPriceRange ? product.compare_at_price_max : (product.compare_at_price || 0);
        
        // Convert to cents
        priceMin = convertToCents(priceMin, hasPriceRange ? product.price_min : product.price);
        priceMax = convertToCents(priceMax, hasPriceRange ? product.price_max : product.price);
        compareAtPriceMin = convertToCents(compareAtPriceMin, hasCompareAtPriceRange ? product.compare_at_price_min : product.compare_at_price);
        compareAtPriceMax = convertToCents(compareAtPriceMax, hasCompareAtPriceRange ? product.compare_at_price_max : product.compare_at_price);
        
        // Check if on sale
        const isOnSale = compareAtPriceMin > 0 && compareAtPriceMin > priceMin;
        
        // Format prices
        let priceDisplay = '';
        let comparePriceDisplay = '';
        
        if (hasPriceRange) {
          const formattedMin = this.formatMoney(priceMin);
          const formattedMax = this.formatMoney(priceMax);
          priceDisplay = `${formattedMin} - ${formattedMax}`;
        } else {
          priceDisplay = this.formatMoney(priceMin);
        }
        
        if (isOnSale) {
          if (hasCompareAtPriceRange) {
            const formattedCompareMin = this.formatMoney(compareAtPriceMin);
            const formattedCompareMax = this.formatMoney(compareAtPriceMax);
            comparePriceDisplay = `${formattedCompareMin} - ${formattedCompareMax}`;
          } else if (compareAtPriceMin > 0) {
            comparePriceDisplay = this.formatMoney(compareAtPriceMin);
          }
        }

        return `
          <a href="${product.url}" class="search-modal__result-item">
            ${imageUrl ? `
              <div class="search-modal__result-image-wrapper">
                <img src="${imageUrl}" alt="${this.escapeHtml(product.title)}" class="search-modal__result-image" loading="lazy">
              </div>
            ` : `
              <div class="search-modal__result-placeholder">
                <svg class="search-modal__result-placeholder-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"></path>
                </svg>
              </div>
            `}
            <div class="search-modal__result-details">
              <h3 class="search-modal__result-title">
                ${this.escapeHtml(product.title)}
              </h3>
              <div class="search-modal__result-price-group">
                ${isOnSale ? `
                  <span class="search-modal__result-price search-modal__result-price--sale">${priceDisplay}</span>
                  ${comparePriceDisplay ? `<span class="search-modal__result-compare-price">${comparePriceDisplay}</span>` : ''}
                ` : `
                  <span class="search-modal__result-price">${priceDisplay}</span>
                `}
              </div>
            </div>
          </a>
        `;
      }).join('');

      // Add "See more" link at the end
      const searchQuery = query || this.currentQuery;
      const seeMoreLink = searchQuery ? `
        <div class="search-modal__see-more">
          <a href="/search?q=${encodeURIComponent(searchQuery)}&type=product" class="search-modal__see-more-link" onclick="window.closeSearchModal();">
            ${this.translations.see_more || 'See more results'}
          </a>
        </div>
      ` : '';

      this.resultsContent.innerHTML = resultsHTML + seeMoreLink;
    }

    renderError() {
      this.resultsContent.innerHTML = `
        <div class="search-modal__empty-state">
          <p class="search-modal__empty-title">${this.translations.something_went_wrong}</p>
          <p class="search-modal__empty-text">${this.translations.please_try_again}</p>
        </div>
      `;
    }

    clearResults() {
      if (this.resultsContent) {
        this.resultsContent.innerHTML = '';
      }
    }

    escapeHtml(text) {
      const div = document.createElement('div');
      div.textContent = text;
      return div.innerHTML;
    }

    formatMoney(cents) {
      // Ensure we're working with a number
      const priceInCents = typeof cents === 'number' ? cents : parseFloat(cents) || 0;
      
      if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
        return Shopify.formatMoney(priceInCents, this.moneyFormat);
      }
      // Fallback formatting if Shopify.formatMoney is not available
      // Shopify API returns prices in cents, so divide by 100
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
      }).format(priceInCents / 100);
    }

    showLoading() {
      if (this.loadingContainer) {
        this.loadingContainer.classList.remove('is-hidden');
      }
      if (this.resultsContainer) {
        this.resultsContainer.classList.add('is-hidden');
      }
    }

    hideLoading() {
      if (this.loadingContainer) {
        this.loadingContainer.classList.add('is-hidden');
      }
      if (this.resultsContainer) {
        this.resultsContainer.classList.remove('is-hidden');
      }
    }
  }

  // Initialize modal search when DOM is ready
  document.addEventListener('DOMContentLoaded', () => {
    const modalElement = document.querySelector('[data-search-modal]');
    if (modalElement) {
      window.modalSearch = new ModalSearch(modalElement);
    }
  });

  if (document.readyState !== 'loading') {
    const modalElement = document.querySelector('[data-search-modal]');
    if (modalElement) {
      window.modalSearch = new ModalSearch(modalElement);
    }
  }
}
